import React, { useEffect, useState } from 'react';

/**
 * Avatar — common avatar for ALL surfaces (Voice-First fix).
 * If the image URL is missing OR fails to load (404/broken), a clean
 * initial-letter fallback renders — never the browser broken-image icon,
 * never alt text inside the circle.
 */
const Avatar = ({ src, alt = '', name = '', size = 40, ring = false, className = '' }) => {
  const label = name || alt || '';
  const initial = (label || '?').charAt(0).toUpperCase();
  const [errored, setErrored] = useState(false);
  useEffect(() => { setErrored(false); }, [src]);
  const showImage = !!src && !errored;
  return (
    <div
      className={`relative inline-flex shrink-0 select-none items-center justify-center overflow-hidden rounded-full bg-secondary align-top ${
        ring ? 'ring-2 ring-offset-2 ring-pink-500' : ''
      } ${className}`}
      style={{ width: size, height: size }}
      role="img"
      aria-label={label}
    >
      {showImage ? (
        <img
          src={src}
          alt=""
          onError={() => setErrored(true)}
          className="h-full w-full object-cover object-center"
          loading="lazy"
          decoding="async"
          draggable={false}
        />
      ) : (
        <span
          className="select-none font-semibold leading-none text-muted-foreground"
          style={{ fontSize: Math.max(10, Math.round(size * 0.42)) }}
          aria-hidden="true"
          data-testid="avatar-fallback-initial"
        >
          {initial}
        </span>
      )}
    </div>
  );
};

export default Avatar;
